import './DetailDivider.css'

const DetailDivider = ({color = "white"}:{color?: string}) => {

    return (
        <div className='shared-detail__divider' style={{ backgroundColor: color }}></div>
    )
}

export default DetailDivider